import React from "react";
//#region types
import { EntityTopCardContentProps } from "models/propTypes/pageLayoutPropTypes";
import { TranslationKeys } from "translations";
import { TodoConstants } from "utils/constants";
//#endregion
//#region components
import { Divider, Grid, Theme, useMediaQuery } from "@mui/material";
import MoreActions from "../../buttons/moreActions";
import QuickActionButton from "../../buttons/quickActionButton";
import StatusIndicatorSmall from "../../stateIndicatorSmall";
import StyledButton from "../../buttons/styledButton";
import TopCardContentSkeleton from "../../skeletons/entityCardLayout/topCardContentSkeleton";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const EntityTopCardContent: React.FC<EntityTopCardContentProps> = (props) => {
  const isScreenWidthXs = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const wrapSx = props.noDescriptionTextWrap
    ? {
        whiteSpace: "normal !important" as const,
        overflow: "visible",
        textOverflow: "unset",
      }
    : undefined;

  return (
    <Grid id={TodoConstants.TopCardId} container className={cssExports.topCardContentWrapper}>
      <div className={cssExports.topCardSkeleton}>
        <TopCardContentSkeleton
          hideTitle={UtilsHelper.isEmpty(props.title)}
          hideSubTitle={UtilsHelper.isEmpty(props.subTitle?.trim())}
          hideDescriptionHeadingOne={UtilsHelper.isEmpty(props.descriptionHeadingOne)}
          hideDescriptionHeadingTwo={UtilsHelper.isEmpty(props.descriptionHeadingTwo)}
          hideDescriptionheadingThree={UtilsHelper.isEmpty(props.descriptionheadingThree)}
          hideFooterText={UtilsHelper.isEmpty(props.footerText)}
          hasFooterButton={props.onViewAllClick !== undefined}
        />
      </div>
      <Grid container direction="column" gap={2} className={cssExports.topCardContent}>
        <Grid item className={cssExports.topSection}>
          <Grid container direction="row" justifyContent="space-between">
            <Grid item>
              <Grid item className={cssExports.todoTypeHeader}>
                {props.title}
              </Grid>
              {props.subTitle ? (
                <Grid item className={cssExports.todoStatus}>
                  {props.subTitle}
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
            {props.quickActions?.length ? (
              <Grid item>
                <Grid container direction="row" spacing={1}>
                  {isScreenWidthXs ? (
                    <MoreActions menuItems={props.quickActions} />
                  ) : (
                    props.quickActions.map((action, i) => (
                      <QuickActionButton {...action} key={i} disbaleSuccessMessage />
                    ))
                  )}
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
        <Grid item>
          <Divider className={cssExports.dividerGray} />
        </Grid>
        <Grid item container className={cssExports.midSection} rowGap={0.5} direction="column">
          {props.descriptionHeadingOne ? (
            <Grid
              item
              className={clsx(cssExports.heading1, !props.noDescriptionTextWrap && cssExports.truncateString)}
              sx={wrapSx}
            >
              {props.descriptionHeadingOne}
            </Grid>
          ) : (
            <></>
          )}
          {props.descriptionHeadingTwo ? (
            <Grid
              item
              className={clsx(cssExports.heading2, !props.noDescriptionTextWrap && cssExports.truncateString)}
              sx={wrapSx}
            >
              {props.descriptionHeadingTwo}
            </Grid>
          ) : (
            <></>
          )}
          {props.descriptionheadingThree ? (
            <Grid
              item
              className={clsx(cssExports.heading3, !props.noDescriptionTextWrap && cssExports.truncateString)}
              sx={wrapSx}
            >
              {props.descriptionheadingThree}
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          className={cssExports.bottomSection}
        >
          <Grid item>
            <Grid item container direction="row" spacing={1} alignItems="center">
              <Grid item>
                <StatusIndicatorSmall displayType={props.statusIndicatorDisplayType} />
              </Grid>
              <Grid item className={clsx(cssExports.footer, cssExports.truncateString)}>
                {props.footerText}
              </Grid>
            </Grid>
          </Grid>
          {props.onViewAllClick ? (
            <Grid item>
              <StyledButton size="xs" secondary onClick={props.onViewAllClick} className={cssExports.viewAll}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AllInfo)}
              </StyledButton>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EntityTopCardContent;
